import { createContext, useContext, useEffect, useRef, useState } from "react";
import { getOtherPublic } from "../actions/otherActions";

// Replaces the previous 25-useState block + duplicated hydrate/loadData logic
// that lived inline in App.js. Pages can read individual values via
// `useSiteConfig()` instead of receiving them through prop drilling.
const SiteConfigContext = createContext(null);

const EMPTY = {
  message: "",
  showMessage: false,
  mainPhoto: "",
  mainPhotoMobile: "",
  pic1: "",
  pic2: "",
  mainHeading: "",
  mainHeadingUrdu: "",
  mainSubheading: "",
  mainSubheadingUrdu: "",
  heading3: "",
  heading3Urdu: "",
  gmail: "",
  twitter: "",
  facebook: "",
  instagram: "",
  copyright: "",
  about: "",
  aboutUrdu: "",
  phoneInfo: "",
  phone2Info: "",
  emailInfo: "",
  addressInfo: "",
  showFinder: false,
  showDetect: false,
  terms: "",
  termsUrdu: "",
  termsContact: "",
  termsContactUrdu: "",
  privacy: "",
  privacyUrdu: "",
};

// Backend `getOtherPublic` returns keys like `phone`, `phone2`, `email`,
// `address` (no Info suffix) and `privacyPolicy`/`privacyPolicyUrdu`. Map both
// shapes so callers don't have to know which one they're getting.
const normalize = (raw = {}) => ({
  ...EMPTY,
  ...raw,
  showMessage: !!raw.showMessage,
  showFinder: !!raw.showFinder,
  showDetect: !!raw.showDetect,
  phoneInfo: raw.phone || raw.phoneInfo || "",
  phone2Info: raw.phone2 || raw.phone2Info || "",
  emailInfo: raw.email || raw.emailInfo || "",
  addressInfo: raw.address || raw.addressInfo || "",
  privacy: raw.privacy || raw.privacyPolicy || "",
  privacyUrdu: raw.privacyUrdu || raw.privacyPolicyUrdu || "",
});

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(() => {
    try {
      const cached = JSON.parse(sessionStorage.getItem("allSiteInfo"));
      return cached ? normalize(cached) : EMPTY;
    } catch {
      return EMPTY;
    }
  });
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    const cached = sessionStorage.getItem("allSiteInfo");
    if (cached) return; // already hydrated from cache

    getOtherPublic()
      .then((res) => {
        if (!isMounted.current) return;
        if (res && res.success === true && res.other && res.other[0]) {
          const data = res.other[0];
          setConfig(normalize(data));
          sessionStorage.setItem("allSiteInfo", JSON.stringify(data));
        }
      })
      .catch((err) => {
        console.log("site config load error:", err);
      });

    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <SiteConfigContext.Provider value={config}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => {
  const ctx = useContext(SiteConfigContext);
  if (ctx == null) return EMPTY;
  return ctx;
};

export default SiteConfigContext;
